<template>
  <div>
    <div style="display: flex; align-items: center; justify-content: center; padding: 0px 0px 10px 0px">
    
    </div>
    <span class="title-user-scr">Cuenta Dzidzil-ha</span>
    <div>Banco: Santander </div>
    <div>Dzidzil-Ha AC </div>
    <div>Cuenta: 65-50692601-6 </div>
    <div style="padding: 0px 0px 10px 0px">Clave Interbancaria : 014910655069260163</div>

   
    <div style="margin: 50px 0">
      <span class="title-user-scr" style="margin-bottom: 30px !important;">Adeudo años anteriores</span>
     <DebtYears :info-user="profile" ></DebtYears>
   </div>

    <v-form ref="formReservation" lazy-validation>
      <span class="title-user-scr">Selecciona el plan de cuotas</span>
      <v-row>
        <v-col>
          <v-select
          v-model="year"
          :items="years"
          item-text="text"
          item-value="value"
          label="Selecciona un año"
          @change="fetchPlans"
        ></v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-select
              v-model="planId"
              :items="maintenplans"
              item-text="concept"
              item-value="id"
              label="Plan de Pagos"
            ></v-select>
        </v-col>
      </v-row>
    </v-form>

      <v-btn 
      block color="blue"
      style="color:white" 
      large rounded 
      :disabled="!planId"
      :to="planId ? { name: 'maintenancefees', params: { planId } } : null"      
      >ver pagos</v-btn>
    <br />   
  
  </div>
</template>


<script>
import adminScheduleMaintenanceService from '@/services/admin/maintenancePayments';
import DebtYears from '@/components/DebtYears.vue';
import userService from '@/services/users';

export default {
  components: { DebtYears },
  data() {
    return{
      year: new Date().getFullYear(), // año actual por default
      years: [],
      maintenplans: [],
      planId: null,
      profile: {},
    }
  },
  created() {
    const currentYear = new Date().getFullYear();
    this.years = [];
    for (let y = 2025; y <= currentYear; y++) {
      this.years.push({
        text: y.toString(),
        value: y,
      });
    }
    this.fetchPlans();  
    this.fetchProfile(); 
  },
  methods: {
    fetchPlans() {  
       this.paymentsmainten = [];   
       const userId = this.$store.getters['session/userId'];
      adminScheduleMaintenanceService.fetchUserSuscriptionsByr(userId, this.year).then((response) => {         
        this.maintenplans = response.data;
        if (this.maintenplans.length > 0) {         
          this.planId = this.maintenplans[0].id; 
        } else {
          this.planId = null; 
          this.maintenplans=[];
        }
      });
    },
    fetchProfile() {
      userService.user().then(async(response) => {
        console.log(response.data);
        this.profile = await response.data;
      });
    },
  }
};
</script>

<style lang="scss" scoped>
@import './src/assets/style.scss';
</style>